module.exports = __webpack_public_path__ + "static/media/step2a.f23e455a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Tour/assets/step2a.png
// module id = 3729
// module chunks = 0